var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 216.031,
    height: 144.074,
    viewBox: "0 0 216.031 144.074",
    id: "dashBoardIcon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5636",
    "data-name": "Group 5636",
    transform: "translate(-15.283 -123.123)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10",
    transform: "translate(23.38 130.324)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_465",
    "data-name": "Path 465",
    d: "M43.79,203.733H15.881v14.415H43.79a7.208,7.208,0,0,0,0-14.415ZM108.6,124.617v27.855a7.2,7.2,0,0,0,14.4,0V123.654h-7.2Zm79.211,79.116a7.208,7.208,0,0,0,0,14.415h24.3V203.733Z",
    transform: "translate(-15.881 -123.654)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_466",
    "data-name": "Path 466",
    d: "M123.3,123.123A107.817,107.817,0,0,0,21.563,267.2H225.035A107.817,107.817,0,0,0,123.3,123.123ZM103.364,252.8a20.992,20.992,0,0,1,39.87,0Zm53.268-6.306,42.175-60.714-60.076,41.809c.176.095.325.217.488.3a35.362,35.362,0,0,0-15.921-3.906A35.823,35.823,0,0,0,88.284,252.8H32.29a91.585,91.585,0,0,1-2.6-21.616,93.613,93.613,0,1,1,187.226,0,91.584,91.584,0,0,1-2.6,21.616H158.314",
    transform: "translate(0 0)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/Dashboard.582cc92caca470b84b499b253beda7cd.svg";
export { ForwardRef as ReactComponent };